<template>
  <tr class="lh">
    <th class="lh">Origin</th>
    <th class="lh">Origin ID</th>
    <th class="lh">Destination</th>
    <th class="lh">Destination ID</th>
    <th class="lh">Via</th>
    <th class="lh">Via ID</th>
  </tr>
</template>

<script>
export default {

}
</script>

<style scoped>
 .lh {
    background-color: #A9D0F5 ;
    color: white;
    font-weight: bold;
    padding: 8px;
    text-align: left;
 }
 th {
  font-weight: bold;
 }
</style>